import { render, staticRenderFns } from "./DynamicAttributeOptionText.vue?vue&type=template&id=877a0c98&"
import script from "./DynamicAttributeOptionText.vue?vue&type=script&lang=ts&"
export * from "./DynamicAttributeOptionText.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports